import React from 'react';
import { Flex, Grid, Typography, theme } from 'antd';

type Props = {
  message: string;
};

function SearchPerformanceCtaRow({ message, children }: React.PropsWithChildren<Props>) {
  const { token } = theme.useToken();
  const screens = Grid.useBreakpoint();
  const isNarrow = !screens.md;

  return (
    <Flex
      vertical={isNarrow}
      align={isNarrow ? 'stretch' : 'center'}
      justify="space-between"
      gap={token.margin}
      style={{
        marginTop: token.margin,
        paddingTop: token.margin,
        borderTop: `${token.lineWidth}px ${token.lineType} ${token.colorBorderSecondary}`,
      }}
    >
      {/* FIXME: no exact token — the prototype caps the measure at 640px. */}
      <Typography.Text type="secondary" style={{ fontSize: token.fontSizeSM, maxWidth: 640 }}>
        {message}
      </Typography.Text>
      {children}
    </Flex>
  );
}

export default SearchPerformanceCtaRow;
